var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadConfirmationDialogStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 154.1 114.2",
    style: {
      enableBackground: "new 0 0 154.1 114.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n.clonoseq-theme #Group_UploadConfirmationDialog_Step2 .st0,\n.clonoseq-theme #Group_UploadConfirmationDialog_Step2 .st2 {\n  fill: #67b8db;\n}\n\n.immunoseq-theme #Group_UploadConfirmationDialog_Step2 .st0,\n.immunoseq-theme #Group_UploadConfirmationDialog_Step2 .st2 {\n  fill: #e9903f;\n}\n#Group_UploadConfirmationDialog_Step2 .st1 {\n  fill: #ffffff;\n}\n#Group_UploadConfirmationDialog_Step2 .st2 {\n  stroke: #ffffff;\n  stroke-width: 1.5;\n}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_UploadConfirmationDialog_Step2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1796",
    transform: "translate(-0.498 0.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5272",
    className: "st0",
    d: "M62.5,20.3c0-0.8,0-1.6,0-2.4c0-0.8-0.4-1.5-1-1.9c-0.5-0.4-1.2-0.5-1.8-0.5H32.6       c-0.1,0-0.3,0-0.4,0c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0-0.7,0-1.1c0-0.3-0.1-0.7-0.2-1c-0.4-1.1-1.4-1.8-2.6-1.7c-4,0-7.9,0-11.9,0       c-0.2,0-0.5,0-0.7,0.1c-1.2,0.3-2.1,1.4-2.1,2.6c0,2.3,0,4.5,0,6.8c0,0,0,0,0,0v24.6c0,1.4,1.1,2.5,2.5,2.5l0,0H60       c1.4,0,2.5-1.1,2.5-2.5l0,0L62.5,20.3C62.5,20.3,62.5,20.4,62.5,20.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    className: "st0",
    d: "M131.4,76.5H131c-9.9,0-19.9,0-29.8,0c-2.3,0.1-4.3,1.5-5.3,3.6c-0.9,2.1-1.9,4.1-2.8,6.1     c-2,4.3-3.9,8.6-5.9,12.9c0,0.1-0.1,0.2-0.2,0.3v-0.2c0-10.1,0-20.2,0-30.3c0-1.3,0.8-2.4,2.1-2.7c0.2,0,0.5-0.1,0.7-0.1     c4,0,8,0,12,0c1.2-0.1,2.3,0.6,2.6,1.8c0.1,0.3,0.1,0.7,0.2,1c0,0.4,0,0.8,0,1.1c0,0.4,0.3,0.8,0.8,0.8c0.1,0,0.3,0,0.4,0h22.7     c0.6,0,1.3,0.1,1.8,0.5c0.6,0.4,1,1.2,1.1,2C131.4,74.3,131.4,75.4,131.4,76.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1797",
    transform: "translate(-567.498 -240.358)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    className: "st0",
    cx: 647.1,
    cy: 325.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    className: "st0",
    cx: 605.1,
    cy: 311,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    className: "st0",
    cx: 619.1,
    cy: 325.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    className: "st0",
    cx: 605.1,
    cy: 297,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    className: "st0",
    cx: 633.1,
    cy: 325.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    className: "st0",
    cx: 640.1,
    cy: 325.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    className: "st0",
    cx: 605.1,
    cy: 318,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    className: "st0",
    cx: 612.1,
    cy: 325.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    className: "st0",
    cx: 605.1,
    cy: 325.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_193",
    className: "st0",
    cx: 605.1,
    cy: 304,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    className: "st0",
    cx: 626.1,
    cy: 325.2,
    r: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    className: "st1",
    d: "M38,24.2l1.5,1.2c1.6,1.2,3.1,2.4,4.7,3.6c0,0,0.1,0.1,0.1,0.1c0,2.9,0,5.8,0,8.8V38H40v-5.3H36     V38h-4.3v-0.1c0-2.9,0-5.8,0-8.8c0,0,0-0.1,0.1-0.1C33.9,27.4,35.9,25.8,38,24.2L38,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3036_1_",
    className: "st1",
    d: "M112.8,101.1c-6.5,0-12.9,0-19.4,0c-0.5,0-1-0.1-1.4-0.4c-0.7-0.6-0.9-1.5-0.5-2.3     c0.3-0.7,0.6-1.3,0.9-2c2.6-5.7,5.2-11.4,7.8-17.1c0.3-0.7,0.7-1.3,1.3-1.8c0.7-0.6,1.6-0.9,2.6-0.9c5,0,10.1,0,15.1,0     c7.8,0,15.6,0,23.4,0c0.3,0,0.5,0,0.8,0c0.9,0.2,1.5,1,1.4,1.9c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.4-0.2,0.6c-2.9,6.3-5.8,12.6-8.7,19     c-0.3,0.8-0.9,1.6-1.6,2.1c-0.6,0.4-1.4,0.7-2.1,0.7C125.7,101.1,119.2,101.1,112.8,101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    className: "st0",
    d: "M109.9,102.7c-6.5,0-12.9,0-19.4,0c-0.5,0-1-0.1-1.4-0.4c-0.7-0.6-0.9-1.5-0.5-2.3     c0.3-0.7,0.6-1.3,0.9-2c2.6-5.7,5.2-11.4,7.8-17.1c0.3-0.7,0.7-1.3,1.3-1.8c0.7-0.6,1.6-0.9,2.6-0.9c5,0,10.1,0,15.1,0     c7.8,0,15.6,0,23.4,0c0.3,0,0.5,0,0.8,0c0.9,0.2,1.5,1,1.4,1.9c0,0.1,0,0.1,0,0.2c0,0.2-0.1,0.4-0.2,0.6c-2.9,6.3-5.8,12.6-8.7,19     c-0.3,0.8-0.9,1.6-1.6,2.1c-0.6,0.4-1.4,0.7-2.1,0.7C122.8,102.7,116.3,102.7,109.9,102.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3194",
    transform: "translate(114.002 39.3) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5273",
    className: "st2",
    d: "M11.5-12.7C11.7-7.3,14.2-1.7,23-1v0.7c0,1.4,0,2.8,0,4.2c0,0.2,0.1,0.5,0.2,0.7       c0.2-0.1,0.4-0.1,0.6-0.3c2.1-1.7,4.2-3.4,6.2-5.1c1.2-1,2.4-1.9,3.6-2.9c0.7-0.6,0.7-0.9,0-1.5c-2.5-2-4.9-4.1-7.4-6.1       c-0.8-0.6-1.5-1.3-2.3-1.9c-0.2-0.1-0.5-0.3-0.8-0.3C23.1-13.3,23-13,23-12.8c0,1.5,0,3,0,4.5v0.8c-2.2,0-4.4-0.4-6.5-1.2       C14.4-9.4,12.6-10.8,11.5-12.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1801_1_",
    transform: "translate(-860.498 -266.955)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184_1_",
    x: 969.6,
    y: 293.1,
    className: "st1",
    width: 28,
    height: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1800_1_",
    transform: "translate(957.878 267.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3034_1_",
    className: "st0",
    d: "M38.3,18.7C38.3,18.7,38.2,18.7,38.3,18.7c-1.7,0-3.3,0-4.9,0c-0.4,0-0.8-0.3-0.9-0.7         c0-0.1,0-0.1,0-0.2c0-1.6,0-3.3,0-4.9c0,0,0,0,0-0.1L38.3,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3035_1_",
    className: "st0",
    d: "M39.4,20.4c-2,0-4,0-6,0c-1,0-1.9-0.5-2.4-1.4c-0.3-0.4-0.4-1-0.4-1.5c0-2,0-4,0-5.9v-0.2         h-0.2c-5.3,0-10.6,0-15.9,0c-0.5,0-1,0.4-1,0.9c0,0,0,0.1,0,0.1c0,11.6,0,23.2,0,34.9c0,0.5,0.4,1,0.9,1c0,0,0,0,0.1,0         c8,0,16.1,0,24.1,0c0.1,0,0.2,0,0.3,0c0.4-0.1,0.7-0.5,0.7-1c0-8.9,0-17.8,0-26.6v-0.2L39.4,20.4z M17.1,24.1c0.1,0,0.2,0,0.3,0         c2,0,16.5,0,18.6,0c0.4,0,0.8,0.2,1,0.6c0.2,0.5-0.1,1-0.5,1.2c-0.1,0-0.2,0.1-0.3,0.1c-1,0-2.1,0-3.1,0c-1,0-14.6,0-15.6,0         c-0.5,0-0.9-0.4-0.9-0.9C16.4,24.5,16.7,24.1,17.1,24.1L17.1,24.1z M36.1,44.7c-0.1,0-0.2,0-0.3,0H17.2c-0.5,0.1-1-0.2-1-0.7         s0.2-1,0.7-1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0h18.6c0.5,0,0.9,0.3,1,0.8C37,44.2,36.6,44.7,36.1,44.7L36.1,44.7z M17.1,36.6         c1.2,0,2.4,0,3.6,0h5.8c3.1,0,6.2,0,9.3,0c0.4,0,0.8,0.2,0.9,0.6c0.1,0.5-0.1,1-0.6,1.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0         c-6.2,0-12.4,0-18.6,0c-0.4,0-0.7-0.2-0.9-0.5c-0.2-0.4,0-1,0.4-1.2C16.9,36.7,17,36.6,17.1,36.6L17.1,36.6z M36.1,32.1         c0,0-0.1,0-0.2,0H17.2c-0.5,0.1-1-0.2-1.1-0.7c-0.1-0.5,0.2-1,0.7-1.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.2,0h9.3c3.1,0,6.2,0,9.3,0         c0.4,0,0.8,0.3,1,0.7c0.1,0.5-0.2,1-0.7,1.1C36.2,32.1,36.1,32.1,36.1,32.1L36.1,32.1z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadConfirmationDialogStep2);
export default __webpack_public_path__ + "static/media/UploadConfirmationDialog_Step2.aec37d80.svg";
export { ForwardRef as ReactComponent };